export default {
  'proTech.proEquip': 'Production equipment',
  'proTech.chiselIntroduce': 'Chisel introduce',
  'proTech.testingInstrument': 'Testing instrument',
  'proTech.techProcess': 'Technological Process'
}
